function AboutUs() {
    return (
        <div>
        <div id="about-us" className="about-us w-full flex flex-col md:flex-row md:px-10 py-20">
            <div className="flex-1 p-4 md:p-10 md:flex-1 h-full flex flex-col gap-4"> {/* Take 3/4 of the width */}
                <h1 className="mb-7 text-left text-3xl md:text-4xl font-extrabold text-white">About Us</h1>
                <p className=" text-gray-300 font-medium ">
                The Directorate of Technical Education, Kerala, is set to host UDYAMA 1.0 between December 7 and 10, 2024, 
                aiming to foster collaboration, skill development, innovation, and entrepreneurship by bridging the gap 
                between academia and industry. This conclave will provide a unique platform for professionals, researchers, and students to connect, 
                share ideas, and explore new opportunities for partnership.
                </p>
                
                <p className=" text-gray-300 font-medium ">
                Focused on healthcare, renewable energy, climate solutions, and education, UDYAMA 1.0 aspires to drive innovation and create sustainable solutions to address key global challenges.
                </p>
            </div>  
            <div className=" md:flex md:flex-1 items-center justify-center p-4  w-full md:max-w-[45%]  "> {/* Take 1/4 of the width */}
                <YouTubePlayer videoId="nk9SM1VwAGA" /> 

        
            </div>
        </div>
        </div>
    );
}

export default AboutUs;


const YouTubePlayer = ({ videoId }) => {
  return (
    <div className="w-full  ">
      <iframe
        width="100%"
        height="350px"
        src={`https://www.youtube.com/embed/${videoId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube video player"
       className="rounded-xl"></iframe>
    </div>
  );
};

// export default YouTubePlayer;



